import React from 'react';
import "../components/PricingPage.css";
import { loadStripe } from '@stripe/stripe-js';
import { useAuth } from '../context/AuthContext';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const plans = [
  {
    name: "Basic",
    price: "$199/month",
    features: [
      "Access to basic features",
      "Email support",
      "Community access"
    ],
    //Test basic
    priceId: "price_1RueesFWOoPQ3uEqxnu8IjFe",
  },
  {
    name: "Pro",
    price: "$399/month",
    features: [
      "Access to all features",
      "Priority email support",
      "Community access",
      "Monthly webinars"
    ],
    //Test pro
    priceId: "price_1Ruf9wFWOoPQ3uEqld8L0E8w",
  },
  {
    name: "Enterprise",
    price: "$699/month",
    features: [
      "All Pro features",
      "Dedicated account manager",
      "Custom solutions"
    ],
    //Test enterprise
    priceId: "price_1RuvBbFWOoPQ3uEq1jotQ3gz",
  }
];

export default function PricingPage() {
    const { user } = useAuth();

    const handleSubscribe = async (priceId) => {
        if (!user) {
            alert("You must be logged in to subscribe.");
            return;
        }
        const token = await user.getIdToken();

        const res = await fetch(process.env.REACT_APP_STRIPE_BACKEND_URL, {
            method: "POST",
            headers: { 
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}` 
             },
            body: JSON.stringify({ priceId }),
        });

        if (!res.ok) {
            const errorData = await res.json();
            console.error("Error creating checkout session:", errorData);
            alert("Failed to create checkout session. Please try again.");
            return;
        }
        
        const data = await res.json();
        console.log("Checkout session created:", data);
        const stripe = await stripePromise;
        if (!stripe) {
            console.error("Stripe.js has not loaded properly.");
            return;
        }

        if (data.error || !data.sessionId) {
            console.error("Error creating checkout session:", data.error || "No session ID returned");
            alert("Failed to create checkout session. Please try again.");
            return;
        }
        console.log("Redirecting to Stripe checkout with session ID:", data.sessionId);
        await stripe.redirectToCheckout({ sessionId: data.sessionId})
    };

    return (
        <div className="pricing-page">
            <h1 className="pricing-title">Choose Your Plan</h1>
            <div className="plan-container">
                {plans.map((plan) => (
                    <div className="plan-card" key ={plan.name}>
                        <h2>{plan.name}</h2>
                        <p className ="price">{plan.price}</p>
                        <p>{plan.description}</p>
                        <ul>
                            {plan.features.map((feature, index) => (
                                <li key={index}>{feature}</li>
                            ))}
                        </ul>
                    <button onClick={() => handleSubscribe(plan.priceId)}>Subscribe</button>
                    </div>
                ))}
            </div>
        </div>
    );
}
